// UK formatting throughout — dates, kilograms, and stones-and-pounds, because
// that is how the weight in the brief is actually spoken about.

export const isoToday = () => new Date().toISOString().slice(0, 10);

export function addDays(iso, n) {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

export function mondayOf(iso) {
  const d = new Date(`${iso}T00:00:00Z`);
  const dow = d.getUTCDay() === 0 ? 7 : d.getUTCDay();
  d.setUTCDate(d.getUTCDate() - (dow - 1));
  return d.toISOString().slice(0, 10);
}

const DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export function fmtDate(iso, style = 'medium') {
  if (!iso) return '';
  const d = new Date(`${iso}T00:00:00Z`);
  const day = d.getUTCDate();
  if (style === 'short') return `${day} ${MONTH[d.getUTCMonth()].slice(0, 3)}`;
  if (style === 'weekday') return DAY[d.getUTCDay()];
  if (style === 'weekday-short') return DAY[d.getUTCDay()].slice(0, 3);
  if (style === 'long') return `${DAY[d.getUTCDay()]} ${day} ${MONTH[d.getUTCMonth()]}`;
  return `${day} ${MONTH[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

export function relativeDay(iso) {
  const today = isoToday();
  if (iso === today) return 'Today';
  if (iso === addDays(today, 1)) return 'Tomorrow';
  if (iso === addDays(today, -1)) return 'Yesterday';
  return fmtDate(iso, 'long');
}

export const kg = (v, dp = 1) => (v == null ? '—' : `${Number(v).toFixed(dp)}kg`);

// 69.4kg reads as 10 st 13 lb, which is how she would describe it out loud.
export function toStone(kgValue) {
  if (kgValue == null) return '—';
  const lbs = kgValue * 2.2046226218;
  const st = Math.floor(lbs / 14);
  const rem = Math.round(lbs - st * 14);
  if (rem === 14) return `${st + 1} st 0 lb`;
  return `${st} st ${rem} lb`;
}

export const cm = (v) => (v == null ? '—' : `${Number(v).toFixed(1)}cm`);

export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-GB'));

export function signed(v, unit = '', dp = 1) {
  if (v == null) return '—';
  const n = Number(v);
  const s = n > 0 ? '+' : n < 0 ? '−' : '';
  return `${s}${Math.abs(n).toFixed(dp)}${unit}`;
}

export function mmss(totalSeconds) {
  const s = Math.max(0, Math.round(totalSeconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

export function minutesLabel(seconds) {
  const m = Math.round(seconds / 60);
  return m >= 1 ? `${m} min` : `${seconds}s`;
}

export const SLOT_LABEL = { breakfast: 'Breakfast', lunch: 'Lunch', dinner: 'Dinner', snack: 'Snack' };
